import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { StateService } from '../../services/state.service';
import { AuthService, ApiService, SnackBarService } from '../../services';
import { ISubuser, LoginModel, Role, User } from 'src/app/services/interfaces';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoginComponent implements OnInit {

  public users: User[] = null;
  public showUserSelection: boolean = false;
  public invalidLogin: boolean = false;
  public emailNotConfirmed: boolean = false;
  public credentials: LoginModel = { username: '', password: '' };
  public mailModal: boolean = false;
  private subuser: any;
  private originaluser: User;
  public emailRegexp: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/gm;
  public errormail: boolean = false;

  constructor(private router: Router, private snackBarService: SnackBarService, private authService: AuthService, private stateService: StateService, private apiService: ApiService) { }

  public ngOnInit(): void {
    // empty
  }

  public login(form: NgForm) {
    this.emailNotConfirmed = false;
    this.invalidLogin = false
    if (form.valid) {
      this.credentials.password = this.credentials.password.trim()
      this.authService.singin(this.credentials)
        .subscribe({
          next: (response: User[]) => {
            this.users = response;

            if (response.length >= 2) {
              this.showUserSelection = true;
            } else {
              this.selectUser(response[0]);
            }
          },
          error: (err: any) => {
            if (err.error === 'Account not confirmed') {
              this.emailNotConfirmed = true;
            } else {
              this.invalidLogin = true
            }
          }
        })
    }
  }
  public goToZilex() {
    window.open('https://zilex.de', '_blank');
  }

  private checkUserEmailAndNavigate(selectedUser: User) {
    this.apiService.getUserSubusers().subscribe({
      next: (subUsersResp: ISubuser[]) => {

        this.subuser = subUsersResp.find(u => u.userId === selectedUser.userId);

        if (this.subuser && this.subuser.mail && this.subuser.mail.trim() !== '' && this.subuser.mail.includes('@')) {

          this.completeLogin(selectedUser);
        } else {

          this.openEmailModal();
        }
      },
      error: (error) => {

        this.completeLogin(selectedUser);
      }
    });
  }
  public openEmailModal() {
    this.mailModal = true;
  }
  public onEmailSubmit(newEmail: string) {

    newEmail = newEmail.trim();

    if (!newEmail.match(this.emailRegexp)) {
      this.errormail = true;
      return;
    }

    this.errormail = false;

    this.subuser.mail = newEmail;

    this.apiService.updateSubuser(this.subuser).subscribe({
      next: (response) => {
        this.stateService.store("jwt", response.token, true);
        this.users = this.stateService.restore('users');
        const user = this.users.find(x => x.userId === this.originaluser.userId);

        if (user) {
          user.token = response.token;
          this.stateService.store('users', this.users, true);
        }
        this.cancelMailModal();
        this.completeLogin(this.originaluser);
      },
      error: (err) => {
        this.snackBarService.open("The email is already used by another user!");
      }
    });
  }
  public cancelMailModal() {
    this.mailModal = false;
  }
  public selectUser(user: User) {

    this.originaluser = user;
    this.showUserSelection = false;

    this.stateService.store("jwt", user.token, true);

    this.apiService.getUserProps().subscribe({
      next: (resp: { propertyKey: string; propertyValue: string; }[]) => {

        resp.forEach((_prop) => {
          user[_prop.propertyKey] = _prop.propertyValue;
        });

        this.checkUserEmailAndNavigate(user);

      },
      error: (error) => {
        this.checkUserEmailAndNavigate(user);
      }
    })

  }

  private completeLogin(user: User) {
    this.stateService.store('user', user, true);
    this.navigate(user);
  }
  private navigate(user: User): void {

    if (user.roles.includes(Role.UserAdmin)) {
      this.router.navigate(["/useradmin/home"]);
    } else if (user.roles.includes(Role.User)) {
      this.router.navigate(["/user/home"]);
    } else if (user.roles.includes(Role.Administrator)) {
      throw new Error('Administrator role not supported.');
    }

  }

  scrollUsers(direction: 'left' | 'right') {

    const wrapper = document.querySelector('.users-wrapper');
    if (wrapper) {
      const scrollAmount = 200;
      if (direction === 'left') {
        wrapper.scrollLeft -= scrollAmount;
      } else {
        wrapper.scrollLeft += scrollAmount;
      }
    }
  }

  closeDialog(event?: MouseEvent) {
    this.showUserSelection = false;

  }

}
